import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

// import { useTranslateContext } from 'gatsby-plugin-translate'

import Links from './Links'
import Copyright from './CopyrightFooter'
import Social from './SocialFooter'
import Certification from  './Certification'

import * as S from './styled'

const Footer = ({ brand }) => {
  const data = useStaticQuery(graphql`
    query {
      Menu: allWordpressExecutiveThemeHeader {        
        nodes {
          sidebars {
            widgets {
              value {
                name
                items {
                  title
                  url
                  wordpress_children {
                    title
                    url
                  }
                }
              }
            }
          }
        }
      }
      Logo: wordpressWpLogo {
        id
        url {
          id
          localFile {
            url
          }
        }
      }
      socialLinks: wordpressExecutiveThemeSettings {
        facebook_url
        instagram_url
        linkedin_url
        youtube_url
        footer_text
        libras_url
        technical_manager
      }
      certification: wordpressWpGatsbyPage(slug: {eq: "home"}) {
        acf {
          has_certification
          certification_url
          certification_image {
            localFile {
              url
            }
          }
        }
      }
    }  
  `)

  const menuMobile = data.Menu.nodes[0].sidebars[0].widgets.filter(function(menuHeader) {
    return menuHeader.value.name == "Menu/Header - Mobile"
  });  
  const menuData = menuMobile[0].value.items

  const links = data.Menu.nodes
  const footerLinks = []
  const footerFix = links.map((Links, index) =>
    Links.sidebars[0].widgets.map((name, index) => {
      if (name.value.name.substring(0, 6) == "Footer") {
        footerLinks.push(name)
      }
    })
  )

  const certification = data.certification.acf;
  const socialLinks = data.socialLinks

  return (
    <S.MainFooterContainer data-testid="main-footer-container">
      <S.FooterSection data-testid="footer-section">
        <S.FooterContainer data-testid="footer-container">
          <S.FooterGrid data-testid="footer-grid">
            <S.LogoContainer data-testid="footer-logo-container">
              <S.LogoBrand
                data-testid="footer-logo"
                brand={brand} />
            </S.LogoContainer>
            <S.LinksContainer data-testid="footer-links-container">
              <Links
                data-testid="footer-links"
                footerLinks={footerLinks}
                socialLinks={socialLinks}
              />
            </S.LinksContainer>
          </S.FooterGrid>
        </S.FooterContainer>
      </S.FooterSection>
      <S.FooterSectionCopiryght data-testid="footer-section-copiryght">
        <S.FooterContainer>
          <S.FooterGridSocials>
            <S.Certification  data-testid="footer-container-certified">
            {
              certification.has_certification &&
              <Certification url={certification.certification_url} image={certification.certification_image.localFile.url}/>
            }
            </S.Certification>
            <Social data-testid="footer-container-socials" socialLinks={socialLinks} />
          </S.FooterGridSocials>
          <S.FooterGridCopyright>
            <Copyright
              data-testid="footer-container-copyright"
              copyrightText={socialLinks}
            ></Copyright>
          </S.FooterGridCopyright>
        </S.FooterContainer>
      </S.FooterSectionCopiryght>
    </S.MainFooterContainer>
  )
}

export default Footer
